export enum ReportTab {
    REPORT = 1,
    INVOICE_PRINTING = 2
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/report-tab.enum.ts